import React from "react";
import TVSub from "../../Components/Products/tv-subscriptions";

const MainTvSub = () => {
	return <TVSub />;
};

export default MainTvSub;
